//Built-in libraries

//Third party libraries

//Custom components
import { HookInput } from 'components/UI/HookForm/Form/Input';
import { HookCheckbox } from 'components/UI/HookForm/Form/Checkbox';
import { HookSelect } from 'components/UI/HookForm/Form/Select';
import HookMaskedInput from 'components/UI/HookForm/Form/MaskedInput';
import Button from 'components/UI/Button';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous
import { States } from '../../../../../../constants';
import { currentUsage, ownerTypeOptions, zoaning } from './constants';
import { useFormContext } from 'react-hook-form';
import { HookRadioGroup } from 'components/UI/HookForm/Form/RadioGroup';
import { HookArray } from 'components/UI/HookForm/Form/Array';

//Component Begin

export default function Information() {
  const { setCurrentStep, updateData } = useApplicationFormContext();
  const {
    watch,
    trigger,
    formState: { errors, isValid },
    getValues,
  } = useFormContext();
  const hasContactName = watch('step1.section1.hasContactName');
  const hasAdditionalAddress = watch('step1.section1.hasAdditionalAddress');

  const onSubmit = () => {
    trigger();
    const formData = getValues('step1');

    if (!isValid) {
      return;
    }

    updateData({
      step1: { ...formData },
    });
    setCurrentStep((prev) => prev + 1);
  };

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>
          Information
        </h3>
        <div className='flex flex-col gap-10'>
          <section className='space-y-4'>
            <h3>Applicant / Business /Borrower Information</h3>
            <div className='grid grid-cols-6 gap-4'>
              <div className='col-span-6'>
                <HookRadioGroup
                  label='Owner Type (Check one)'
                  name='step1.section1.ownerType'
                  id='ownership-type'
                  options={ownerTypeOptions.map((o) => ({
                    label: o,
                    value: o,
                  }))}
                />
              </div>
              <label className=''>Building Owner(s)</label>
              <div className='col-span-6'>
                <HookArray
                  name='step1.section1.buildingOwners'
                  defaultValues={{ name: '' }}
                >
                  {(arrayFieldName, removeButton, arrayId) => (
                    <div className='grid grid-cols-12 gap-4 w-full h-full content-start'>
                      <HookInput
                        key={arrayId}
                        customClassName='col-span-12'
                        label='Name'
                        name={`${arrayFieldName}.name`}
                        type='text'
                      />
                      {removeButton}
                    </div>
                  )}
                </HookArray>
                <div className='text-red-600 text-sm mt-1'>
                  {errors?.step1?.section1?.buildingOwners?.message}
                </div>
              </div>
              <HookInput
                customClassName='col-span-6'
                label='Street Address'
                name='step1.section1.streetAddress'
                type='text'
              />
              <HookInput
                customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
                label='City'
                name='step1.section1.city'
                type='text'
              />
              <HookSelect
                customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
                label='State / Province'
                name='step1.section1.state'
                options={States.map((state) => ({
                  label: state.name,
                  value: state.name,
                }))}
              />
              <HookMaskedInput
                customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
                label='ZIP / Postal code'
                name='step1.section1.zipCode'
                maskedComponent='zipCode'
              />
               <HookMaskedInput
                customClassName='col-span-6 sm:col-span-6 md:col-span-2'
                label='EIN#'
                name='step1.section1.ein'
                id='ein'
                maskedComponent='ein'
              />
               <HookMaskedInput
                customClassName='col-span-6 sm:col-span-6 md:col-span-2'
                label='DUNS#'
                name='step1.section1.duns'
                id='duns'
                maskedComponent='ein'
              />
              <HookMaskedInput
                customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
                label='Phone Number'
                name='step1.section1.phone'
                id='phone'
                maskedComponent='phone'
              />
              <HookMaskedInput
                customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
                label='Fax'
                name='step1.section1.fax'
                id='fax'
                maskedComponent='phone'
              />
              <HookInput
                customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
                label='Email'
                name='step1.section1.email'
                type='email'
                placeholder='myemail@example.com'
              />
            </div>
            <div>
            <div className='grid grid-cols-6 gap-4 mt-8'>
                <HookCheckbox
                  className='col-span-6'
                  label='Contact Name (if different from above)'
                  name='step1.section1.hasContactName'
                />
                {hasContactName && (
                  <HookInput
                    customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
                    label='Name'
                    name='step1.section1.additionalName'
                    type='text'
                  />
                )}
                <HookCheckbox
                  className='col-span-6'
                  label='Address (if different from above)'
                  name='step1.section1.hasAdditionalAddress'
                />
                {hasAdditionalAddress && (
                  <HookInput
                    customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
                    label='Address'
                    name='step1.section1.additionalAddress'
                    type='text'
                  />
                )}
              </div>
            </div>
          </section>
          <section className='space-y-4'>
            <h3>Building Information</h3>
            <div className='grid grid-cols-6 gap-4'>
              <HookInput
                customClassName='col-span-6'
                label='Property Street Address'
                name='step1.section2.streetAddress'
                type='text'
              />
              <HookInput
                customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
                label='City'
                name='step1.section2.city'
                type='text'
                disabled
              />
              <HookSelect
                customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
                label='State / Province'
                name='step1.section2.state'
                options={States.map((state) => ({
                  label: state.name,
                  value: state.name,
                }))}
                value='Alabama'
                disabled
              />
              <HookMaskedInput
                customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
                label='ZIP / Postal code'
                name='step1.section2.zipCode'
                maskedComponent='zipCode'
              />
              <HookMaskedInput
                customClassName='col-span-3 sm:col-span-3 lg:col-span-2'
                label='Number of Buildings'
                name='step1.section2.buildingCount'
                maskedComponent='numeric'
              />
              <HookSelect
                customClassName='col-span-3 sm:col-span-3 lg:col-span-2'
                label='Current Usage'
                name='step1.section2.currentUsage'
                options={currentUsage.map((usage) => ({
                  label: usage,
                  value: usage,
                }))}
              />
              <HookSelect
                customClassName='col-span-3 sm:col-span-3 lg:col-span-2'
                label='Zoning'
                name='step1.section2.zoning'
                options={zoaning.map((z) => ({
                  label: z,
                  value: z,
                }))}
              />
            </div>
          </section>
        </div>

        <div className='flex gap-4 justify-end mt-5'>
          <Button
            label='Previous'
            btnStyle='neutral'
            type='button'
            onClick={() => setCurrentStep((prev) => prev - 1)}
          />
          <Button
            label='Next'
            btnStyle='primary'
            type='submit'
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  );
}
